import { css } from '@nfront/global-styles';

import { colors, root } from './theme';
import { fontstackSansSerif } from './typography';

const globalStyles = css`
  body {
    font-family: ${fontstackSansSerif};
    margin: 0;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    width: 100%;
  }

  body * {
    box-sizing: border-box;
  }

  html {
    font-size: ${`${root}px`};
    -webkit-font-smoothing: antialiased;
  }

  a {
    color: black;
    cursor: pointer;
    text-decoration: none;
  }

  .active > span {
    border-bottom: 2px solid ${colors.black};
  }

  [hidden] {
    display: none;
  }

  @keyframes flash {
    0% {
      color: ${colors.red};
    }
    100% {
      color: ${colors.white};
    }
  }
`;

export default globalStyles;
